module.exports = __webpack_public_path__ + "media/images/flags/1x1/vnm-b2f7944d0ddbe0b7f27db04b309103da.svg";